<template>
    <div id="dvtelalogin" v-show="usuario.id === null">
        <div class="container-fluid" style="height: 100%;">
            <div class="row" style="height: 100%;">   
                <div class="col-md-12" id="dvlogin" style="padding-bottom: 15px;">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-2 col-lg-4">
                            </div>
                            <div class="col-md-8 col-lg-5">
                                <div class="screen">
                            <div class="screen__content">
                                <form class="login">
                                    <div class="login__logo">
                                        <img src="../assets/logo.png" alt="Logo do Sistema">
                                    </div>
                                    <div class="login__field">
                                        <i class="fa fa-handshake-o" aria-hidden="true"></i>
                                        <input type="text" class="login__input" v-model="idcliente" @blur="mtdcarregardadoscli()" placeholder="Seu Id">
                                    </div>
                                    <div class="login__field">
                                        <i class="fa fa-user-o" aria-hidden="true"></i>
                                        <input type="text" class="login__input" v-model="loginusuario" placeholder="Usuário">
                                    </div>
                                    <div class="login__field">
                                        <i class="fa fa-key" aria-hidden="true"></i>
                                        <input type="password" v-model="senhausuario" class="login__input" placeholder="Senha">
                                    </div>
                                    <button  @click.prevent="mtdlogarusuario()" class="button login__submit">
                                        <span class="button__text">Entrar</span>
                                    </button>				
                                </form>
                                
                            </div>
                            <div class="screen__background">
                                <span class="screen__background__shape screen__background__shape4"></span>
                                <span class="screen__background__shape screen__background__shape3"></span>		
                                <span class="screen__background__shape screen__background__shape2"></span>
                                <span class="screen__background__shape screen__background__shape1"></span>
                            </div>		
                        </div>
                            </div>   
                            <div class="col-md-2 col-lg-3">
                            </div>                                                        
                        </div>
                    </div>
                </div>
                <div  id="dvside">
                    
                </div>                                 
            </div>
        </div>    
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
  name: "login",
  data: function() {
    return {     
        idcliente           : '',        
        lstsistemascliente  : [],
        sistemaselecionado  : [],
        nomecliente         : '',
        loginusuario        : '',
        senhausuario        : '' 
    };
  },
  methods:{
      mtdlogarusuario(){
        if (this.idcliente === ''){
            this.$toastr.w('Id. do cliente deve ser informado!', 'Atenção!');
            $('#edidcliente').focus();
            return;
        }
        if (this.loginusuario === ''){
            this.$toastr.w('Login do usuário deve ser informado!', 'Atenção!');
            $('#edusuario').focus();
            return;
        }        
        if (this.senhausuario === ''){
            this.$toastr.w('Senha do usuário deve ser informada!', 'Atenção!');
            $('#edsenha').focus();
            return;
        }      
        if (this.sistemaselecionado.length === 0){
            this.$toastr.w('Informe o sistema para o acesso!', 'Atenção!');
            $('#btsistema').focus();
            return;            
        }      
        var vself           = this;   
        let loader          = vself.$loading.show();             
        let dthracesso      = new Date();
        let parametros      = [
            {parametro: 'op',           valor : 'logarws'}, 
            {parametro: 'loginusu',     valor : vself.loginusuario}, 
            {parametro: 'senhausu',     valor : vself.senhausuario},
            {parametro: 'idclientesac', valor : vself.idcliente},
            {parametro: 'idcliente',    valor : vself.idcliente}
        ];
        //quando for testar habilitar essa linha
        vself.sistemaselecionado.endereco = 'dracosys.top';
        
        let retorno     = util.reqaxios(parametros, 'post', vself.sistemaselecionado.endereco+'/controller/rotinasusuario.php');
        retorno.then(function (response) {
            loader.hide();
            if (parseInt(response.data.qtdusu) > 0){
                let payload = {
                    id               : parseInt(response.data.idusuario),
                    nome             : response.data.nome,
                    foto             : response.data.foto,
                    descgrupo        : response.data.descgrupo,
                    todasfiliais     : response.data.todasfiliais,
                    idvendedor       : response.data.idvendedor,
                    nomevendedor     : response.data.nomevendedor,
                    descontoprodutos : response.data.descontoprodutos,
                    descontoprodutosprazo : response.data.descontoprodutosprazo,
                    descontoservicos : response.data.descontoservicos,
                    descontojuros    : response.data.descontojuros,
                    descontomulta    : response.data.descontomulta,
                    cardresumopedidos: response.data.cardresumopedidos,
                    cardfinanceiro   : response.data.cardfinanceiro,
                    cardrecursos : response.data.cardrecursos,
                    cardvendedores   : response.data.cardvendedores,
                    cardcompra       : response.data.cardcompra,
                    definirsenhalogin: response.data.definirsenhalogin,
                    idclientesac     : vself.idcliente,
                    dbcliente        : vself.sistemaselecionado.dbcliente,
                    sistema          : vself.sistemaselecionado.nomesis,
                    adrsrv           : vself.sistemaselecionado.endereco,
                    limitecreditoautorizar : response.data.limitecreditoautorizar,
                    receberinfsistema      : response.data.receberinfsistema,
                    estoquegeralconsultas  : response.data.estoquegeralconsultas                   
                };
                vself.$store.commit('MUDAR_USUARIO_LOGADO',payload);

                //Muda o configpath
                payload = {
                    pathcontrole    : 'https://'+vself.sistemaselecionado.endereco+'/controller/',
                    pathselect2     : 'https://'+vself.sistemaselecionado.endereco+'/controller/select2remoto.php',
                    pathselect2sql  : 'https://'+vself.sistemaselecionado.endereco+'/controller/select2sql.php',
                    pathimagens     : 'https://'+vself.sistemaselecionado.endereco+'/',
                    patharquivos    : 'https://'+vself.sistemaselecionado.endereco+'/', 
                    pathconferencias: 'arquivos/manager/conferencias/',                        
                    pathretornos    : 'arquivos/manager/retornos/',        
                    pathofx         : 'arquivos/manager/ofx/',        
                    pathimgprodutos : 'imagens/manager/produtos/',
                    pathimgpedidos  : 'imagens/manager/pedidos/',
                    pathimgfiliais  : 'imagens/manager/filiais/',
                    pathimgclientes : 'imagens/manager/clientes/',
                    pathimgusuarios : 'imagens/manager/usuarios/',
                    pathcertificados: 'arquivos/manager/certificados/',
                    pathtarefas     : 'arquivos/manager/tarefas/'                    
                }
                vself.$store.commit('MUDAR_CONFIG_PATHS',payload);

                window.localStorage.setItem('dbcliente',            vself.sistemaselecionado.dbcliente);
                window.localStorage.setItem('sistema',              vself.sistemaselecionado.nomesis);                
                window.localStorage.setItem('adrsrv',               vself.sistemaselecionado.endereco);                
                window.localStorage.setItem('idcliente',            vself.idcliente);
                window.localStorage.setItem('idusuario',            parseInt(response.data.idusuario));
                window.localStorage.setItem('nome',                 response.data.nome);
                window.localStorage.setItem('idvendedor',           parseInt(response.data.idvendedor));
                window.localStorage.setItem('nomevendedor',         response.data.nomevendedor);
                window.localStorage.setItem('descontoprodutos',     response.data.descontoprodutos);
                window.localStorage.setItem('descontoprodutosprazo',response.data.descontoprodutosprazo);
                window.localStorage.setItem('descontoservicos',     response.data.descontoservicos);
                window.localStorage.setItem('descontojuros',        response.data.descontojuros);
                window.localStorage.setItem('descontomulta',        response.data.descontomulta);
                window.localStorage.setItem('cardresumopedidos',    response.data.cardresumopedidos);
                window.localStorage.setItem('cardfinanceiro',       response.data.cardfinanceiro);
                window.localStorage.setItem('cardrecursos',     response.data.cardrecursos);
                window.localStorage.setItem('cardvendedores',       response.data.cardvendedores);
                window.localStorage.setItem('cardcompra',           response.data.cardcompra);             
                window.localStorage.setItem('limitecreditoautorizar', response.data.limitecreditoautorizar);   
                window.localStorage.setItem('receberinfsistema',    response.data.receberinfsistema);   
                window.localStorage.setItem('estoquegeralconsultas',response.data.estoquegeralconsultas);                   
                window.localStorage.setItem('foto',                 response.data.foto);
                window.localStorage.setItem('descgrupo',            response.data.descgrupo);
                window.localStorage.setItem('todasfiliais',         response.data.todasfiliais);
                window.localStorage.setItem('definirsenhalogin',    vself.definirsenhalogin);
                window.localStorage.setItem('loginusu',             vself.loginusuario);
                window.localStorage.setItem('senhausu',             vself.senhausuario);                
                window.localStorage.setItem('dthracesso',           dthracesso);
                
                //limpa variáveis do login
                $("#dvconteudoapp").css({"display": "block"});         
                vself.dbcliente    = '';
                vself.loginusuario = '';
                vself.senhausuario = '';                
            }else{                
                vself.$toastr.w(response.data.msg, 'Atenção!');    
                $('#edusuario').focus();
            }
        }).catch(function (response) {
            loader.hide();
            console.log(response.message);
            vself.$toastr.e('Erro ao tentar fazer o login do usuário. Favor tente novamente mais tarde.', 'Erro!');
        });        
      },
      mtdcarregardadoscli(){
        var vself           = this;   
        if (vself.idcliente.trim() !== ''){            
            let loader          = vself.$loading.show();             
            let parametros      = [
                {parametro: 'op',           valor : 'dadoslogin'}, 
                {parametro: 'idclientesac', valor : vself.idcliente}
            ];
            //conecta direto no servidor do sac para coletar as informações do clientes
            let retorno     = util.reqaxios(parametros, 'post', 'dracosys.top/gerencia/controller/auxiliares.php');
            retorno.then(function (response) {
                loader.hide();
                if (response.data.fantasia !== ''){
                    vself.nomecliente           = response.data.fantasia;
                    vself.lstsistemascliente    = response.data.sistemas;  
                    if (vself.lstsistemascliente.length === 0){
                        vself.nomecliente           = '';
                        vself.lstsistemascliente    = [];                      
                        vself.sistemaselecionado    = [];                        
                        vself.$toastr.i('Cliente sem contrato(s) ativo(s)!', 'Atenção!');    
                        $('#edidcliente').focus();                    
                    }else{                  
                        if (vself.lstsistemascliente.length > 0){
                            vself.mtdselecionasistema(vself.lstsistemascliente[0]);
                        }else{
                            vself.sistemaselecionado = [];
                        }
                        $('#edusuario').focus(); 
                    }
                }else{                
                    vself.nomecliente           = '';
                    vself.lstsistemascliente    = [];                      
                    vself.sistemaselecionado    = [];
                    vself.$toastr.w('Cliente não encontrado ou sem contrato ativo!', 'Atenção!');    
                    $('#edidcliente').focus();
                }
            }).catch(function (response) {
                loader.hide();
                console.log(response.message);
                vself.$toastr.e('Erro ao tentar carregar informações do cliente. Favor tente novamente mais tarde.', 'Erro!');
            }); 
        }                 
      },
      mtdselecionasistema(sistema){
          this.sistemaselecionado = sistema;
      }
  },
  mounted: function () {          
        let vself = this;
        $(document).keypress(function(e) {
            if (e.which == 13) {
                if (window.localStorage.getItem('idusuario') === null){
                    vself.mtdlogarusuario();
                }                
            }
        });        
        if (window.localStorage.getItem('idusuario') != null){      
            let payload = {
                id                  : window.localStorage.getItem('idusuario'),
                nome                : window.localStorage.getItem('nome'),
                foto                : window.localStorage.getItem('foto'),
                descgrupo           : window.localStorage.getItem('descgrupo'),
                todasfiliais        : window.localStorage.getItem('todasfiliais'),
                idvendedor          : window.localStorage.getItem('idvendedor'),
                nomevendedor        : window.localStorage.getItem('nomevendedor'),
                descontoprodutos    : window.localStorage.getItem('descontoprodutos'),
                descontoprodutosprazo: window.localStorage.getItem('descontoprodutosprazo'),
                descontoservicos    : window.localStorage.getItem('descontoservicos'),
                descontojuros       : window.localStorage.getItem('descontojuros'),
                descontomulta       : window.localStorage.getItem('descontomulta'),
                cardresumopedidos   : window.localStorage.getItem('cardresumopedidos'),
                cardfinanceiro      : window.localStorage.getItem('cardfinanceiro'),
                cardrecursos        : window.localStorage.getItem('cardrecursos'),
                cardvendedores      : window.localStorage.getItem('cardvendedores'),
                cardcompra          : window.localStorage.getItem('cardcompra'),                                
                dbcliente           : window.localStorage.getItem('dbcliente'),
                idclientesac        : window.localStorage.getItem('idcliente'),
                sistema             : window.localStorage.getItem('sistema'),
                adrsrv              : window.localStorage.getItem('adrsrv'),
                definirsenhalogin   : window.localStorage.getItem('definirsenhalogin'),
                limitecreditoautorizar : window.localStorage.getItem('limitecreditoautorizar'),
                receberinfsistema      : window.localStorage.getItem('receberinfsistema'),
                estoquegeralconsultas  : window.localStorage.getItem('estoquegeralconsultas') 
            };            
            this.$store.commit('MUDAR_USUARIO_LOGADO',payload);

            //Muda o configpath
            payload = {
                pathcontrole    : 'https://www.'+window.localStorage.getItem('adrsrv')+'/controller/',
                pathselect2     : 'https://www.'+window.localStorage.getItem('adrsrv')+'/controller/select2remoto.php',
                pathselect2sql  : 'https://www.'+window.localStorage.getItem('adrsrv')+'/controller/select2sql.php',
                pathimagens     : 'https://www.'+window.localStorage.getItem('adrsrv')+'/',
                patharquivos    : 'https://www.'+window.localStorage.getItem('adrsrv')+'/', 
                pathconferencias: 'arquivos/manager/conferencias/',                        
                pathretornos    : 'arquivos/manager/retornos/',        
                pathofx         : 'arquivos/manager/ofx/',        
                pathimgprodutos : 'imagens/manager/produtos/',
                pathimgpedidos  : 'imagens/manager/pedidos/',
                pathimgfiliais  : 'imagens/manager/filiais/',
                pathimgclientes : 'imagens/manager/clientes/',
                pathimgusuarios : 'imagens/manager/usuarios/',
                pathcertificados: 'arquivos/manager/certificados/',
                pathtarefas     : 'arquivos/manager/tarefas/'                    
            }
            this.$store.commit('MUDAR_CONFIG_PATHS',payload);            
        }
        if (this.usuario.id === null){            
            $('#edidcliente').focus();
            $("#dvconteudoapp").css({"display": "none"});         
        }
  },
  computed:{
    usuario (){
        return this.$store.state.usuario;
    }      
  },
  watch:{
  }    
}
</script>
<style>
    #btsistema{
        border-top-left-radius: 0px !important; 
        border-bottom-left-radius: 0px !important;
    }
   
    #dvtelalogin{
        position: absolute;
        top: 0;
        z-index: 1032;
        width: 100%;
        height: 100%;
        background: white;
    }

    #dvlogin{
        padding-top: 15px;
        background: white;
    }    
    label, h6{
        color: #666666;
        font-weight: 700;
    }
    #dvnomecliente{
        margin-top: 10px;
        margin-bottom: 5px;
        border: 1px solid #0acf97;
        border-radius: 4px;        
        background: #0acf97;
        width: 100%;
        color: white;
        font-weight: 500;
        padding: 10px;
    }

    @import url('https://fonts.googleapis.com/css?family=Raleway:400,700');

* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;	
	font-family: Raleway, sans-serif;
}

.login__logo {
    text-align: center; /* Centraliza o logo horizontalmente */
    margin-bottom: 20px; /* Espaçamento inferior para separar o logo dos campos de entrada */
}

.login__logo img {
    max-width: 77px; /* Defina um tamanho máximo para o logo */
    height: auto; /* Mantém a proporção do logo */
}

body {
	background: linear-gradient(90deg, #C7C5F4, #776BCC);		
}

.container {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
}

.screen {		
	background: linear-gradient(90deg, #5D54A4, #7C78B8);		
	position: relative;	
	height: 600px;
	width: 360px;	
	box-shadow: 0px 0px 24px #5C5696;
}

.screen__content {
	z-index: 1;
	position: relative;	
	height: 100%;
}

.screen__background {		
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 0;
	-webkit-clip-path: inset(0 0 0 0);
	clip-path: inset(0 0 0 0);	
}

.screen__background__shape {
	transform: rotate(45deg);
	position: absolute;
}

.screen__background__shape1 {
	height: 520px;
	width: 520px;
	background: #FFF;	
	top: -50px;
	right: 120px;	
	border-radius: 0 72px 0 0;
}

.screen__background__shape2 {
	height: 220px;
	width: 220px;
	background: #6C63AC;	
	top: -172px;
	right: 0;	
	border-radius: 32px;
}

.screen__background__shape3 {
	height: 540px;
	width: 190px;
	background: linear-gradient(270deg, #5D54A4, #6A679E);
	top: -24px;
	right: 0;	
	border-radius: 32px;
}

.screen__background__shape4 {
	height: 400px;
	width: 200px;
	background: #7E7BB9;	
	top: 420px;
	right: 50px;	
	border-radius: 60px;
}

.login {
	width: 320px;
	padding: 30px;
	padding-top: 100px;
}

.login__field {
	padding: 20px 0px;	
	position: relative;	
}

.login__icon {
	position: absolute;
	top: 30px;
	color: #7875B5;
}

.login__input {
	border: none;
	border-bottom: 2px solid #D1D1D4;
	background: none;
	padding: 10px;
	padding-left: 24px;
	font-weight: 700;
	width: 75%;
	transition: .2s;
}

.login__input:active,
.login__input:focus,
.login__input:hover {
	outline: none;
	border-bottom-color: #6A679E;
}

.login__submit {
	background: #fff;
	font-size: 14px;
	margin-top: 30px;
	padding: 16px 20px;
	border-radius: 26px;
	border: 1px solid #D4D3E8;
	text-transform: uppercase;
	font-weight: 700;
	display: flex;
	align-items: center;
	width: 100%;
	color: #4C489D;
	box-shadow: 0px 2px 2px #5C5696;
	cursor: pointer;
	transition: .2s;
}

.login__submit:active,
.login__submit:focus,
.login__submit:hover {
	border-color: #6A679E;
	outline: none;
}

.button__icon {
	font-size: 24px;
	margin-left: auto;
	color: #7875B5;
}

.social-login {	
	position: absolute;
	height: 140px;
	width: 160px;
	text-align: center;
	bottom: 0px;
	right: 0px;
	color: #fff;
}

.social-icons {
	display: flex;
	align-items: center;
	justify-content: center;
}

.social-login__icon {
	padding: 20px 10px;
	color: #fff;
	text-decoration: none;	
	text-shadow: 0px 0px 8px #7875B5;
}

.social-login__icon:hover {
	transform: scale(1.5);	
}
</style>